import GaugeTemplate from '../../html/components/gauge.html'
import GaugeMarkTemplate from '../../html/components/gauge-mark.html'

import Component from '../shared/component'
import Relation, {MemberOf, HasMany} from '../shared/mixins/relation'

const gaugeMarks = Relation()

function round (number, decimals) {
  const factor = Math.pow(10, decimals)
  return Math.round(number * factor) / factor
}

export const Gauge = Component('v-gauge', {
  mixins: [
    HasMany(gaugeMarks, 'marks')
  ],
  template: GaugeTemplate,
  props: {
    value: {
      description: `
        The value of the gauge. Must be between 0 and 1.
      `,
      type: [
        String,
        Number
      ],
      default: 0,
      validator (value) {
        return value >= 0 && value <= 1
      }
    },
    size: {
      description: `
        The size of the gauge.
      `,
      type: String,
      default: 'small',
      valid: [
        'small',
        'large'
      ]
    },
    animate: {
      description: `
        Whether or not to animate the gauge when first displayed. Transitions will still be applied when the value of the gauge and its marks change.
      `,
      type: Boolean,
      default: true
    }
  },
  computed: {
    classes () {
      return {
        'is-animated': this.animate,
        [`is-${this.size}`]: this.size,
        [`is-threshold-${this.threshold}`]: this.threshold
      }
    },

    percentage () {
      return Math.round(Math.min(100, Math.max(0, Number(this.value))) * 100)
    },

    threshold () {
      const p = this.percentage
      switch (true) {
        case p <= 30: return 1
        case p <= 40: return 2
        case p <= 50: return 3
        case p <= 60: return 4
        case p <= 65: return 5
        case p <= 70: return 6
        case p <= 75: return 7
        case p <= 80: return 8
        case p <= 85: return 9
        case p <= 90: return 10
        case p <= 95: return 11
        default: return 12
      }
    },

    radius () {
      return round(100 / (Math.PI * 2), 2)
    },

    thickness () {
      return this.size === 'large' ? 2.5 : 3.5
    },

    viewBox () {
      const diameter = this.radius * 2
      const size = diameter + this.thickness
      return `0 0 ${size} ${size}`
    }
  }
})

export const GaugeMark = Component('v-gauge-mark', {
  mixins: [
    MemberOf(gaugeMarks, 'gauge')
  ],
  template: GaugeMarkTemplate,
  props: {
    value: {
      description: `
        The value of the gauge mark. Must be between 0 and 1.
      `,
      type: [
        String,
        Number
      ],
      default: 0
    }
  }
})
